<template>
    <div>
        <div id="searchContainer" class="shops-search text-center w-full z-50"
            :class="{ 'fixed shops-search-stick': searchIsFixed }">
            <div id="searchBar"
                class="flex">
                <gmap-autocomplete
                    @place_changed="setPlace"
                    selectFirstOnEnter
                    ref="shopsSearchInput"
                    class="opacity-100 h-10 pl-3 pr-3 rounded-l-sm flex-grow shops-search__input outline-none cursor-default min-w-0 z-70"
                    placeholder="Enter City and State or Zip Code"
                    aria-label="Type a city, state, or zip code to search for shops nearby"
                    style="opacity:1">
                </gmap-autocomplete>
                <ButtonGeoLocate v-if="geoLocateBefore"
                    class="rounded-none z-70"/>
                <button type="button"
                    class="btn-white rounded-none pr-2 pl-2 z-70"
                    @click="focusSearch"
                    aria-label="Click to search for shops near the city, state, or zip code you entered"
                    data-tooltip="Search">
                    <IconSearch v-if="!currentlySearching"
                        viewBox="0 0 24 24"
                        class="inline-block w-6 h-6 text-red-dark mt-1 z-70"
                        role="img"
                        alt="An image of a magnifying glass"/>
                    <div v-else class="spinner w-6 z-70"></div>
                </button>
                <ButtonGeoLocate v-if="!geoLocateBefore"
                    class="rounded-l-none border-l z-70"
                    data-tooltip="Use my location" />
            </div>
        </div>
        <div v-show="searchIsFixed && stickyOffset > -10" class="w-screen h-40 pin-t pin-r pin-l bg-black-transparent fixed z-40">
        </div>
    </div>
</template>

<script>
import IconSearch from 'icon/search.svg';
import ButtonGeoLocate from '@/js/components/ButtonGeoLocate.vue';
import { mapActions, mapState } from 'vuex';
import router from '../router';

export default {
    data() {
        return {
            screenSize: {
                isSmall: false,
                specificSize: ''
            },
            searchIsFixed: false,
            stickyOffset: 0,
            searchBar: null,
            searchContainer: null,
            previousInnerWidth: 0
        };
    },
    components: {
        IconSearch,
        ButtonGeoLocate
    },
    props: {
        buttonText: {
            type: String,
            required: false
        },
        geoLocateBefore: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        ...mapActions('locations', [
            'selectSearchedLocation',
            'selectGeoLocation'
        ]),
        setPlace(place) {
            const location = {
                address: '',
                city: '',
                state: '',
                zip: '',
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng()
            };
            let addressType;
            let val;

            place.address_components.forEach((addressPart) => {
                [addressType] = addressPart.types;
                val = addressPart.long_name;

                switch (addressType) {
                case 'street_number':
                    location.address = val;
                    break;
                case 'route':
                    location.address = `${location.address}  ${val}`;
                    break;
                case 'locality':
                    location.city = val;
                    break;
                case 'administrative_area_level_1':
                    location.state = val;
                    break;
                case 'country':
                    location.country = val;
                    break;
                case 'postal_code':
                    location.zip = val;
                    break;
                default:
                    break;
                }
            });
            this.selectSearchedLocation(location, true);
            router.push('shops');
        },
        focusSearch() {
            this.$refs.shopsSearchInput.$refs.input.focus();
        },
        handleScroll() {
            if (window.scrollY > this.searchBar.getBoundingClientRect().bottom + this.searchBar.clientHeight - this.stickyOffset) {
                this.searchIsFixed = true;
                this.$root.$emit('searchFixedTrue');
            } else {
                this.searchIsFixed = false;
                this.$root.$emit('searchFixedFalse');
            }
            this.resizeSearchBar();
        },
        handleResize() {
            if (window.innerWidth < 900) {
                this.screenSize.isSmall = true;
                if (window.innerWidth < 600) {
                    this.screenSize.specificSize = 'xs';
                    this.stickyOffset = 90;
                } else {
                    this.screenSize.specificSize = 'sm';
                    this.stickyOffset = 15;
                }
            } else if (window.innerWidth < 1200) {
                this.screenSize.isSmall = false;
                this.screenSize.specificSize = 'md';
                this.stickyOffset = -185;
            } else {
                this.screenSize.isSmall = false;
                this.screenSize.specificSize = 'lg';
                this.stickyOffset = -185;
            }
            this.previousInnerWidth = window.innerWidth;
            this.resizeSearchBar();
        },
        resizeSearchBar() {
            if (!this.searchIsFixed) {
                this.searchContainer.style.width = '100%';
            } else if (this.screenSize.isSmall) {
                this.searchContainer.style.width = '65%';
            } else {
                this.searchContainer.style.width = '50%';
            }
        }
    },
    computed: {
        ...mapState('shops', ['currentlySearching']),
        ...mapState('locations', ['isCurrentLocation'])
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.searchBar = document.getElementById('searchBar');
        this.searchContainer = document.getElementById('searchContainer');
        this.handleScroll();
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        isCurrentLocation() {
            if (this.isCurrentLocation) {
                this.$refs.shopsSearchInput.$refs.input.value = '';
            }
        }
    }
};
</script>

<style>
</style>
